<template>
  <card :title="$t('gc-software:currentVersion')" no-body no-footer>
    <ul slot="card-table" class="list-group">
      <li v-for="(version, indexVersion) in currentVersion" :key="indexVersion" class="list-group-item border-0 py-2">{{ version.description }}</li>
    </ul>
  </card>
</template>

<script>
import { isEmpty, orderBy } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

export default {
  props: {
    eui: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      getting: false,
      currentVersion: null
    }
  },

  computed: {
    ...mapGetters(['gateway'])
  },

  watch: {
    eui () {
      // Reset data, and get data from new gateway
      this.currentVersion = null
    },

    gateway () {
      // Do not refresh is we olready have the data
      if (!isEmpty(this.currentVersion) || this.getting) return

      this.getCurrentVersion()
    }
  },

  created () {
    eventBus.$on('gateway-update-success', this.getCurrentVersion)

    this.getCurrentVersion()
  },

  destroyed () {
    eventBus.$off('gateway-update-success', this.getCurrentVersion)
  },

  methods: {
    async getCurrentVersion () {
      if (isEmpty(this.gateway)) return

      if (!this.gateway.connection) {
        eventBus.$emit('message-info', this.$t('gc-software:gatewayNotConnected'))
        return
      }

      this.getting = true

      let error, response
      [error, response] = await to(this.$api.getGatewayCurrentVersions(this.gateway))
      if (!error && response) this.currentVersion = orderBy(response.data.versions, ['description'])

      this.getting = false
    }
  }
}
</script>
